import React, { useEffect, useState } from "react";
import { Spinner } from "reactstrap";
import { useParams } from "react-router-dom";

import PodiumCard from "./PodiumCard.js";
import ValetApi from "../api/Api.js";

const PodiumDetail = () => {
    const { id } = useParams();
    const [podium, setPodium] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(
        function fetchPodiumAtMount() {
            async function fetchPodium() {
                try {
                    const podiumRes = await ValetApi.getPodiumById(id);
                    // console.log("PODIUM RES FOR TESTING ", podiumRes.data.podium);
                    setPodium(podiumRes.data.podium);
                    setLoading(false);
                } catch (err) {
                    console.error(err);
                }
            }
            fetchPodium();
        },
        [id]
    );

    if (loading) {
        return (
            <Spinner
                color="primary"
                style={{ width: `100%` }}
            />
        );
    } else
        return (
            <div>
                <PodiumCard podium={podium} />
            </div>
        );
};

export default PodiumDetail;
